var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAlbania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.044 11.8756H19.2486C19.6063 11.501 19.8265 10.9938 19.8265 10.4348C19.8265 9.28228 18.8922 8.3479 17.7396 8.3479C17.0135 8.3479 16.3743 8.7189 16.0005 9.28146C15.6267 8.7189 14.9874 8.3479 14.2613 8.3479C13.1088 8.3479 12.1744 9.28228 12.1744 10.4348C12.1744 10.9938 12.3946 11.501 12.7523 11.8756H6.95703C6.95703 13.4124 8.29559 14.6582 9.83228 14.6582H9.73953C9.73953 16.195 10.9853 17.4408 12.5222 17.4408C12.5222 17.9386 12.6534 18.4052 12.8824 18.8092L10.5743 21.1174L12.3452 22.8882L14.8572 20.3762C14.9555 20.4123 15.0573 20.4412 15.1625 20.4609L13.6445 23.8881L16.0005 26.4348L18.3564 23.888L16.8385 20.4608C16.9437 20.4411 17.0454 20.4122 17.1438 20.3761L19.6558 22.888L21.4267 21.1172L19.1185 18.809C19.3475 18.4051 19.4787 17.9384 19.4787 17.4406C21.0155 17.4406 22.2613 16.1949 22.2613 14.658H22.1687C23.7053 14.6581 25.044 13.4124 25.044 11.8756Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAlbania);
export default __webpack_public_path__ + "static/media/flag_albania.2e9613c5a92863396ddf6374b067c5f0.svg";
export { ForwardRef as ReactComponent };